export const caES = {
  common: {
    search: "Cerca...",
    create: "Nou",
    new: "Nou",
    cancel: "Cancel·la",
    delete: "Suprimeix",
    edit: "Edita",
    theme: "Tema",
    signOut: "Tanca la sessió",
    noMatches: "No s'ha trobat cap coincidència",
    tryDifferentSearch: "Prova amb un terme de cerca diferent.",
    light: "Clar",
    dark: "Fosc",
    system: "Sistema",
    loading: "S'està carregant...",
    note: "Nota",
    insight: "Anàlisi",
    newSource: "Font nova",
    newNotebook: "Quadern nou",
    newPodcast: "Podcast nou",
    language: "Idioma",
    english: "English",
    chinese: "简体中文",
    japanese: "日本語",
    french: "Français",
    russian: "Русский",
    bengali: "বাংলা",
    catalan: "Català",
    spanish: "Español",
    german: "Deutsch",
    polish: "Polski",
    turkish: "Türkçe",
    source: "Font",
    notebook: "Quadern",
    podcast: "Podcast",
    quickActions: "Accions ràpides",
    quickActionsDesc: "Navegació, cerca, preguntes, tema",
    appName: "Open Notebook",
    add: "Afegeix",
    remove: "Elimina",
    confirm: "Confirma",
    warning: "Avís",
    error: "Error",
    success: "Correcte",
    model: "Model",
    back: "Enrere",
    next: "Següent",
    done: "Fet",
    processing: "S'està processant...",
    creating: "S'està creant...",
    linked: "Enllaçat",
    adding: "S'està afegint...",
    addSelected: "Afegeix la selecció",
    customModel: "Model personalitzat",
    failed: "ha fallat",
    current: "Actual",
    save: "Desa",
    writeNote: "Escriu una nota",
    batchMode: "Mode per lots",
    optional: "Opcional",
    type: "Tipus",
    title: "Títol",
    created: "Creat {time}",
    updated: "Actualitzat {time}",
    actions: "Accions",
    noResults: "Sense resultats",
    references: "Referències",
    refreshPage: "Prova de recarregar la pàgina",
    refresh: "Recarrega",
    aiGenerated: "Generat per IA",
    human: "Humà",
    unknown: "Desconegut",
    notes: "Notes",
    chat: "Xat",
    deleteForever: "Suprimeix per sempre",
    connectionError: "Error de connexió",
    unableToConnect: "No es pot connectar al servidor de l'API",
    retryConnection: "Torna a connectar",
    diagnosticInfo: "Informació de diagnòstic",
    version: "Versió",
    built: "Compilat",
    apiUrl: "URL de l'API",
    frontendUrl: "URL del frontal",
    checkConsoleLogs: "Consulta la consola del navegador per veure els registres detallats (cerca missatges de 🔧 [Config])",
    yes: "Sí",
    no: "No",
    saving: "S'està desant...",
    description: "Descripció",
    saveToNote: "Desa a una nota",
    copyToClipboard: "Copia al porta-retalls",
    close: "Tanca",
    insights: "Anàlisis",
    progress: "Progrés",
    deleting: "S'està suprimint...",
    created_label: "Creat",
    updated_label: "Actualitzat",
    download: "Baixa",
    saveChanges: "Desa els canvis",
    name: "Nom",
    default: "Per defecte",
    nameRequired: "El nom és obligatori",
    modelConfiguration: "Configuració del model",
    resetToDefault: "Restableix els valors per defecte",
    reasoning: "Raonament",
    searchTerms: "Termes de cerca",
    strategy: "Estratègia",
    individualAnswers: "Respostes individuals ({count})",
    finalAnswer: "Resposta final",
    notebookLabel: "Quadern: {name}",
    itemNotFound: "No s'ha pogut trobar aquest {type}",
    accessibility: {
      transformationViews: "Vistes de transformació",
      searchKB: "Pregunta o cerca a la base de coneixement",
      enterQuestion: "Introdueix la teva pregunta per a la base de coneixement",
      enterSearch: "Introdueix la consulta de cerca",
      searchKBBtn: "Cerca a la base de coneixement",
      podcastViews: "Vistes de podcast",
      ytVideo: "Vídeo de YouTube",
      askResponse: "Resposta a la pregunta",
      searchNotebooks: "Cerca quaderns",
    },
    url: "URL",
    errorDetails: "Detalls de l'error",
    editTransformation: "Edita la transformació",
    retry: "Torna-ho a provar",
    traditionalChinese: "繁體中文",
    portuguese: "Português",
    completed: "completat",
    saveSuccess: "S'ha desat correctament",
    contextModes: {
      off: "No s'inclou al xat",
      insights: "Només anàlisis",
      full: "Contingut complet",
      clickToCycle: "Fes clic per canviar",
    },
    clickToEdit: "Fes clic per editar",
  },
  apiErrors: {
    notebookNotFound: "No s'ha trobat el quadern",
    sourceNotFound: "No s'ha trobat la font",
    transformationNotFound: "No s'ha trobat la transformació",
    fileUploadFailed: "Ha fallat la càrrega del fitxer",
    urlRequired: "Cal una URL per al tipus d'enllaç",
    contentRequired: "Cal contingut per al tipus de text",
    invalidSourceType: "Tipus de font no vàlid",
    processingFailed: "Ha fallat el processament",
    failedToQueue: "Ha fallat l'addició a la cua de processament",
    invalidSortBy: "El camp d'ordenació ha de ser type, title, created, updated, insights_count o embedded",
    invalidSortOrder: "L'ordre d'ordenació ha de ser 'asc' o 'desc'",
    accessDenied: "Accés al fitxer denegat",
    fileNotFoundOnServer: "No s'ha trobat el fitxer al servidor",
    searchFailed: "Ha fallat la cerca",
    askFailed: "Ha fallat la consulta",
    pleaseEnterQuestion: "Introdueix una pregunta",
    pleaseConfigureModels: "Configura tots els models necessaris",
    failedToCreateSession: "Ha fallat la creació de la sessió",
    failedToUpdateSession: "Ha fallat l'actualització de la sessió",
    failedToDeleteSession: "Ha fallat la supressió de la sessió",
    failedToSendMessage: "Ha fallat l'enviament del missatge",
    unauthorized: "Accés no autoritzat; comprova la teva contrasenya",
    invalidPassword: "Contrasenya incorrecta",
    embeddingModelRequired: "Aquesta funció requereix un model d'incrustació. Configura'n un a la secció Models.",
    strategyModelNotFound: "No s'ha trobat el model d'estratègia",
    answerModelNotFound: "No s'ha trobat el model de resposta",
    finalAnswerModelNotFound: "No s'ha trobat el model de resposta final",
    noAnswerGenerated: "No s'ha pogut generar cap resposta",
    genericError: "S'ha produït un error inesperat",
  },
  connectionErrors: {
    apiTitle: "No es pot connectar al servidor de l'API",
    apiDesc: "No s'ha pogut establir connexió amb el servidor de l'API d'Open Notebook",
    dbTitle: "Ha fallat la connexió amb la base de dades",
    dbDesc: "El servidor de l'API s'està executant, però no es pot accedir a la base de dades",
    troubleshooting: "Això normalment significa:",
    apiUnreachable1: "El servidor de l'API no s'està executant",
    apiUnreachable2: "El servidor de l'API s'executa en una adreça diferent",
    apiUnreachable3: "Problemes de connectivitat de xarxa",
    dbFailed1: "SurrealDB no s'està executant",
    dbFailed2: "La configuració de la connexió amb la base de dades és incorrecta",
    dbFailed3: "Problemes de xarxa entre l'API i la base de dades",
    quickFixes: "Solucions ràpides:",
    setApiUrl: "Estableix la variable d'entorn API_URL:",
    checkSurreal: "Comprova si SurrealDB s'està executant:",
    seeDocumentation: "Per obtenir instruccions detallades de configuració, consulta:",
    docLink: "Documentació d'Open Notebook",
    showTechnical: "Mostra els detalls tècnics",
    attemptedUrl: "URL intentada",
    message: "Missatge",
    technicalDetails: "Detalls tècnics",
    stackTrace: "Traça de la pila",
    retryLabel: "Torna a connectar",
    retryHint: "Prem R o fes clic al botó per tornar a connectar",
    dockerLabel: "Per a Docker",
    localDevLabel: "Per al desenvolupament local",
  },
  auth: {
    loginTitle: "Open Notebook",
    loginDesc: "Introdueix la teva contrasenya per accedir a l'aplicació",
    passwordPlaceholder: "Contrasenya",
    signingIn: "S'està iniciant la sessió...",
    signIn: "Inicia la sessió",
    connectErrorHint: "No es pot connectar al servidor. Comprova si l'API s'està executant.",
  },
  navigation: {
    collect: "Recull",
    process: "Processa",
    create: "Crea",
    manage: "Gestiona",
    sources: "Fonts",
    notebooks: "Quaderns",
    askAndSearch: "Pregunta i cerca",
    podcasts: "Podcasts",
    models: "Models",
    transformations: "Transformacions",
    transformation: "Transformació",
    settings: "Configuració",
    advanced: "Avançat",
    nav: "Navegació",
    language: "Canvia l'idioma",
    theme: "Tema",
    ask: "Pregunta",
  },
  notebooks: {
    title: "Quaderns",
    newNotebook: "Quadern nou",
    searchPlaceholder: "Cerca quaderns...",
    archived: "Arxivat",
    archive: "Arxiva",
    unarchive: "Desarxiva",
    deleteNotebook: "Suprimeix el quadern",
    deleteNotebookDesc: "Segur que vols suprimir «{name}»? Aquesta acció no es pot desfer.",
    deleteNotebookLoading: "S'està carregant la previsualització de la supressió...",
    deleteNotebookNotes: "Se suprimiran {count} nota(es) de manera permanent.",
    deleteNotebookNoNotes: "No hi ha notes a suprimir.",
    deleteNotebookExclusiveSources: "{count} font(s) existeix(en) només en aquest quadern.",
    deleteNotebookSharedSources: "{count} font(s) es comparteix(en) amb altres quaderns i es desenllaçarà(n).",
    deleteNotebookNoSources: "No hi ha fonts en aquest quadern.",
    deleteExclusiveSourcesLabel: "Suprimeix les fonts exclusives",
    keepExclusiveSourcesLabel: "Desenllaça i conserva",
    activeNotebooks: "Quaderns actius",
    archivedNotebooks: "Quaderns arxivats",
    tileView: "Vista de mosaic",
    listView: "Vista de llista",
    notFound: "No s'ha trobat el quadern",
    notFoundDesc: "El quadern sol·licitat no existeix.",
    updated: "Actualitzat",
    namePlaceholder: "Nom del quadern",
    addDescription: "Afegeix una descripció...",
    noNotesYet: "Encara no hi ha notes",
    deleteNote: "Suprimeix la nota",
    deleteNoteConfirm: "Segur que vols suprimir aquesta nota? Aquesta acció no es pot desfer.",
    noteCreatedSuccess: "S'ha creat la nota correctament",
    failedToCreateNote: "Ha fallat la creació de la nota",
    noteUpdatedSuccess: "S'ha actualitzat la nota correctament",
    failedToUpdateNote: "Ha fallat l'actualització de la nota",
    noteDeletedSuccess: "S'ha suprimit la nota correctament",
    failedToDeleteNote: "Ha fallat la supressió de la nota",
    createNew: "Crea un quadern nou",
    createNewDesc: "Introdueix un nom i una descripció opcional per començar.",
    descPlaceholder: "Afegeix aquí més informació sobre aquest quadern...",
    createSuccess: "S'ha creat el quadern correctament",
    updateSuccess: "S'ha actualitzat el quadern correctament",
    deleteSuccess: "S'ha suprimit el quadern correctament",
    recentlyViewed: "Vistos recentment",
    toggleRecentlyViewed: "Commuta els vistos recentment",
    recentlyViewedNotebook: "Quadern",
    recentlyViewedSource: "Font",
    lastViewed: "Vist {{time}}",
  },
  sources: {
    bulkContext: "Context",
    includeAllInContext: "Inclou-les totes al context",
    includeAllInsights: "Inclou-les totes (només informacions)",
    includeAllFull: "Inclou-les totes (contingut complet)",
    excludeAllFromContext: "Exclou-les totes del context",
    title: "Fonts",
    add: "Afegeix una font",
    addNew: "Afegeix una font nova",
    addExisting: "Afegeix una font existent",
    delete: "Suprimeix la font",
    statusPreparing: "S'està preparant",
    statusQueued: "En cua",
    statusProcessing: "S'està processant",
    statusCompleted: "Completat",
    statusFailed: "Ha fallat",
    statusPreparingDesc: "S'està preparant per al processament",
    statusQueuedDesc: "Esperant per ser processat",
    statusProcessingDesc: "S'està processant",
    statusCompletedDesc: "Processat correctament",
    statusFailedDesc: "Ha fallat el processament",
    failedToLoad: "Ha fallat la càrrega de les fonts",
    allSourcesDesc: "Consulta aquí totes les teves fonts. Pots afegir-ne de noves o gestionar les existents.",
    allSources: "Totes les fonts",
    insights: "Anàlisis",
    yes: "Sí",
    no: "No",
    loadingMore: "S'està carregant més...",
    noSourcesYet: "Encara no hi ha fonts",
    allSourcesDescShort: "Consulta aquí totes les teves fonts.",
    cannotSaveNoteNoNotebook: "No es pot desar la nota: l'ID del quadern no està disponible",
    createFirstSource: "Afegeix la primera font per començar a construir la teva base de coneixement.",
    deleteSourceConfirm: "Segur que vols suprimir aquesta font?",
    deleteConfirm: "Segur que vols suprimir aquest element?",
    deleteConfirmWithTitle: "Segur que vols suprimir «{title}»?",
    deleteSuccess: "S'ha suprimit la font correctament. Nota: per suprimir el fitxer de l'emmagatzematge, cal activar l'opció «suprimeix el fitxer» a la pàgina de configuració.",
    failedToDelete: "Ha fallat la supressió de la font",
    sourceQueued: "Font afegida a la cua",
    sourceQueuedDesc: "La font s'ha enviat per al processament en segon pla. Pots controlar el progrés a la llista de fonts.",
    sourceAddedSuccess: "S'ha afegit la font correctament",
    failedToAddSource: "Ha fallat l'addició de la font",
    sourceUpdatedSuccess: "S'ha actualitzat la font correctament",
    failedToUpdateSource: "Ha fallat l'actualització de la font",
    sourceDeletedSuccess: "S'ha suprimit la font correctament",
    failedToDeleteSource: "Ha fallat la supressió de la font",
    fileUploadedSuccess: "S'ha carregat el fitxer correctament",
    failedToUploadFile: "Ha fallat la càrrega del fitxer",
    sourceRequeued: "S'ha tornat a afegir la font a la cua",
    sourceRequeuedDesc: "S'ha tornat a afegir la font a la cua de processament.",
    failedToRetry: "Ha fallat el reintent",
    sourcesAddedToNotebook: "S'han afegit {count} font(s) al quadern",
    failedToAddSourcesToNotebook: "Ha fallat l'addició de fonts al quadern",
    partialAddSuccess: "S'han afegit {success} font(s); {failed} han fallat",
    sourceRemovedFromNotebook: "S'ha eliminat la font del quadern correctament",
    failedToRemoveSourceFromNotebook: "Ha fallat l'eliminació de la font del quadern",
    removeConfirm: "Segur que vols eliminar-lo del quadern?",
    checking: "S'està comprovant...",
    untitledSource: "Font sense títol",
    maxItems: "màx. {count}",
    insightsCount: "{count} anàlisis",
    details: "Detalls",
    detailsTitle: "Detalls de la font",
    content: "Contingut",
    metadata: "Metadades",
    type: {
      link: "Enllaç",
      file: "Fitxer",
      text: "Text",
    },
    id: "ID de la font",
    topics: "Temes",
    embedded: "Incrustat",
    notEmbedded: "No incrustat",
    embedContent: "Incrusta el contingut",
    embedding: "S'està incrustant...",
    alreadyEmbedded: "Ja incrustat",
    downloadFile: "Baixa el fitxer",
    fileUnavailable: "Fitxer no disponible",
    preparing: "S'està preparant...",
    generateNewInsight: "Genera una anàlisi nova",
    selectTransformation: "Selecciona una transformació...",
    noInsightsYet: "Encara no hi ha anàlisis",
    createFirstInsight: "Crea la primera anàlisi amb una transformació de les que hi ha a dalt",
    viewInsight: "Visualitza l'anàlisi",
    deleteInsight: "Suprimeix l'anàlisi",
    deleteInsightConfirm: "Segur que vols suprimir aquesta anàlisi? Aquesta acció no es pot desfer.",
    insightGenerationStarted: "S'ha iniciat la generació de l'anàlisi. Apareixerà en breu.",
    editNote: "Edita la nota",
    createNote: "Crea una nota",
    addTitle: "Afegeix un títol...",
    untitledNote: "Nota sense títol",
    writeNotePlaceholder: "Escriu el contingut de la nota aquí...",
    saveNote: "Desa la nota",
    createNoteBtn: "Crea la nota",
    createFirstNote: "Crea la primera nota per capturar anàlisis i observacions.",
    urlLabel: "URL(s) *",
    fileLabel: "Fitxer(s) *",
    textContentLabel: "Contingut de text *",
    enterUrlsPlaceholder: "Introdueix les URL, una per línia\nhttps://exemple.com/article1\nhttps://exemple.com/article2",
    batchUrlHint: "Enganxa múltiples URL (una per línia) per a la importació per lots",
    invalidUrlsDetected: "S'han detectat URL no vàlides:",
    lineLabel: "Línia {line}",
    fixInvalidUrls: "Corregeix o elimina les URL no vàlides per continuar",
    selectMultipleFilesHint: "Selecciona múltiples fitxers per a la importació per lots. Compatibles: Documents (PDF, DOC, DOCX, PPT, XLS, EPUB, TXT, MD), Multimèdia (MP4, MP3, WAV, M4A), Imatges (JPG, PNG), Arxius (ZIP)",
    selectedFiles: "Fitxers seleccionats:",
    textPlaceholder: "Enganxa o escriu el contingut aquí...",
    htmlDetected: "S'ha detectat contingut HTML. Es convertirà a Markdown després del processament.",
    titlePlaceholder: "Posa un títol descriptiu a la teva font",
    batchTitlesAuto: "Els títols es generaran automàticament per a cada font.",
    batchCommonSettings: "S'aplicaran els mateixos quaderns i transformacions a tots els elements.",
    urlsCount: "{count} URL(s)",
    filesCount: "{count} fitxer(s)",
    addSource: "Afegeix una font",
    notEmbeddedAlert: "Contingut no incrustat",
    notEmbeddedDesc: "Aquest contingut no s'ha incrustat per a la cerca vectorial. La incrustació habilita capacitats de cerca avançada i millora la descoberta de contingut.",
    openOnYoutube: "Obre a YouTube",
    urlCopied: "URL copiada al porta-retalls",
    viewSource: "Visualitza la font",
    noInsightSelected: "No s'ha seleccionat cap anàlisi",
    sourceInsight: "Anàlisi de la font",
    manageNotebooks: "Gestiona els quaderns",
    manageNotebooksDesc: "Gestiona quins quaderns contenen aquesta font",
    noNotebooksAvailable: "No hi ha quaderns disponibles",
    loadFailed: "Ha fallat la càrrega dels detalls de la font",
    removeFromNotebook: "Elimina del quadern",
    retryProcessing: "Torna a processar",
    refreshContent: "Actualitza el contingut",
    deleteSource: "Suprimeix la font",
    retry: "Reintenta",
    addExistingTitle: "Afegeix fonts existents",
    addExistingDesc: "Selecciona fonts existents de tots els teus quaderns per afegir-les a l'actual.",
    searchPlaceholder: "Cerca fonts per nom o URL...",
    noNotebooksFound: "No s'ha trobat cap quadern.",
    showingFirst100: "Es mostren les primeres 100 fonts. Utilitza la cerca per trobar-ne d'específiques.",
    selectedCount: "{count} fonts seleccionades",
    added: "Afegit el {date}",
    addUrl: "Afegeix una URL",
    uploadFile: "Carrega un fitxer",
    enterText: "Introdueix text",
    processDescription: "La IA processarà i analitzarà el contingut.",
    processingFiles: "S'estan processant els teus fitxers...",
    titleRequired: "Cal un títol per al contingut de text",
    titleGenerated: "Si es deixa buit, es generarà un títol a partir del contingut",
    batchCount: "Es processaran {count} {type}",
    enableEmbedding: "Activa la incrustació per a la cerca",
    embeddingDesc: "Permet que aquesta font es trobi en cerques vectorials i consultes d'IA",
    embeddingAlways: "La incrustació s'activa automàticament",
    embeddingAlwaysDesc: "La configuració actual permet incrustar sempre el contingut per a la cerca vectorial.",
    embeddingNever: "La incrustació està desactivada",
    embeddingNeverDesc: "La configuració actual omet la incrustació. La cerca vectorial no estarà disponible per a aquesta font.",
    changeInSettings: "Pots canviar-ho a la Configuració",
    notFound: "No s'ha trobat la font",
    noContent: "No hi ha contingut disponible",
    insightsDesc: "Anàlisis generades per l'anàlisi del model",
    uploadedFile: "Fitxer carregat",
    fileUnavailableDesc: "Aquest fitxer no està disponible per raons del sistema d'emmagatzematge.",
    batchSuccess: "S'ha(n) creat {count} font(s) correctament",
    batchFailed: "Ha fallat la creació de les {count} fonts",
    batchPartial: "{success} correctes, {failed} fallades",
    submittingSource: "S'està enviant la font per al processament...",
    processingBatchSources: "S'estan processant {count} fonts. Això pot trigar uns moments.",
    processingSource: "S'està processant la teva font. Això pot trigar uns moments.",
    maxFilesAllowed: "Màxim {count} fitxers per lot",
  },
  chat: {
    sessions: "Sessions",
    sessionTitlePlaceholder: "Escriu un títol aquí...",
    noSessions: "Encara no hi ha sessions de xat",
    deleteSession: "Suprimeix la sessió",
    deleteSessionDesc: "Segur que vols suprimir aquesta sessió de xat? Aquesta acció no es pot desfer.",
    sendPlaceholder: "Pregunta qualsevol cosa sobre les teves fonts...",
    sessionsTitle: "Sessions de xat",
    chatWith: "Xat amb {name}",
    startConversation: "Inicia una conversa sobre aquest/a {type}",
    askQuestions: "Fes preguntes per entendre millor el contingut",
    pressToSend: "Prem {key} per enviar",
    model: "Model",
    createToStart: "Crea una sessió per començar.",
    chatWithNotebook: "Xat amb el quadern",
    unableToLoadChat: "No es pot carregar el xat",
    noDescription: "Sense descripció",
    startByCreating: "Comença creant el teu primer quadern per organitzar la teva recerca.",
    messagesCount: "{count} missatges",
    sessionCreated: "S'ha creat la sessió de xat",
    sessionUpdated: "S'ha actualitzat la sessió",
    sessionDeleted: "S'ha suprimit la sessió",
  },
  searchPage: {
    askAndSearch: "Pregunta i cerca",
    chooseAMode: "Tria un mode",
    askBeta: "Pregunta (beta)",
    search: "Cerca",
    askYourKb: "Pregunta a la teva base de coneixement (beta)",
    askYourKbDesc: "El model de llenguatge respondrà la teva consulta basant-se en els documents de la teva base de coneixement.",
    question: "Pregunta",
    enterQuestionPlaceholder: "Introdueix la teva pregunta...",
    pressToSubmit: "Prem Cmd/Ctrl+Retorn per enviar",
    noEmbeddingModel: "No pots usar aquesta funció perquè no tens cap model d'incrustació seleccionat. Configura'n un a la pàgina Models.",
    usingCustomModels: "Usant models personalitzats",
    usingDefaultModels: "Usant models per defecte",
    advanced: "Avançat",
    strategy: "Estratègia",
    answer: "Resposta",
    final: "Final",
    ask: "Pregunta",
    processing: "S'està processant...",
    saveToNotebooks: "Desa als quaderns",
    searchDesc: "Cerca a la teva base de coneixement paraules clau o conceptes específics",
    enterSearchPlaceholder: "Introdueix la consulta de cerca...",
    pressToSearch: "Prem Retorn per cercar",
    searchType: "Tipus de cerca",
    vectorSearchWarning: "La cerca vectorial requereix un model d'incrustació. Només està disponible la cerca de text.",
    textSearch: "Cerca de text",
    vectorSearch: "Cerca vectorial",
    searchIn: "Cerca a",
    searchSources: "Cerca a les fonts",
    searchNotes: "Cerca a les notes",
    resultsFound: "S'han trobat {count} resultats",
    matches: "Coincidències ({count})",
    noResultsFor: "No s'han trobat resultats per a «{query}»",
    notSet: "No configurat",
    saveToNotebook: "Desa al quadern",
    saveSuccess: "S'ha desat correctament al quadern",
    saveError: "Ha fallat el desament al quadern",
    selectNotebook: "Selecciona un quadern",
    searchAndAsk: "Cerca i pregunta",
    searchResultsFor: "Resultats de cerca per a «{query}»",
    askAbout: "Pregunta sobre «{query}»",
    orSearchKb: "O cerca a la teva base de coneixement",
    saving: "S'està desant...",
    advancedModelTitle: "Selecció avançada de models",
    advancedModelDesc: "Tria models específics per a cada fase del procés de consulta",
    strategyModel: "Model d'estratègia",
    answerModel: "Model de resposta",
    finalAnswerModel: "Model de resposta final",
    selectStrategyPlaceholder: "Selecciona el model d'estratègia",
    selectAnswerPlaceholder: "Selecciona el model de resposta",
    selectFinalPlaceholder: "Selecciona el model de resposta final",
    saveChanges: "Desa els canvis",
    processingQuestion: "S'està processant la teva pregunta...",
  },
  podcasts: {
    generateEpisode: "Genera un episodi de podcast",
    generateEpisodeDesc: "Selecciona el contingut a incloure i configura els detalls de l'episodi abans de generar-lo.",
    content: "Contingut",
    contentDesc: "Tria quaderns, fonts i notes per incloure en aquest episodi.",
    itemsSelected: "{count} elements seleccionats",
    tokens: "{count} tokens",
    chars: "{count} caràcters",
    loadingNotebooks: "S'estan carregant els quaderns...",
    noNotebooksFoundInPodcasts: "No s'ha trobat cap quadern. Crea un quadern i afegeix contingut abans de generar un podcast.",
    noContentSelected: "No s'ha seleccionat cap contingut",
    summary: "Resum",
    fullContent: "Contingut complet",
    untitledSource: "Font sense títol",
    untitledNote: "Nota sense títol",
    episodeSettings: "Configuració de l'episodi",
    episodeProfile: "Perfil de l'episodi",
    episodeProfilePlaceholder: "Selecciona un perfil d'episodi",
    episodeName: "Nom de l'episodi",
    episodeNamePlaceholder: "per exemple, La IA i el futur del treball",
    additionalInstructions: "Instruccions addicionals",
    instructionsPlaceholder: "Qualsevol consell addicional per afegir al resum de l'episodi...",
    generating: "S'està generant...",
    generate: "Genera",
    hostPlaceholder: "Presentador {number}",
    profileRequired: "Cal un perfil d'episodi",
    profileRequiredDesc: "Selecciona un perfil d'episodi abans de generar el podcast.",
    nameRequired: "Cal el nom de l'episodi",
    nameRequiredDesc: "Proporciona un nom per a l'episodi.",
    addContext: "Afegeix context",
    addContextDesc: "Selecciona almenys una font o nota per incloure a l'episodi.",
    generationFailed: "Ha fallat la generació del podcast",
    speakerProfile: "Perfil del locutor",
    usesSpeakerProfile: "Usa el perfil del locutor",
    sources: "Fonts",
    notes: "Notes",
    noSources: "No hi ha fonts disponibles en aquest quadern.",
    noNotes: "No hi ha notes disponibles en aquest quadern.",
    selectMode: "Selecciona el mode",
    buildContextFailed: "Ha fallat la construcció del context. Revisa les teves seleccions.",
    podcastTaskStarted: "S'ha iniciat la tasca del podcast",
    loadingProfiles: "S'estan carregant els perfils d'episodi...",
    noProfilesFound: "No s'ha trobat cap perfil d'episodi. Crea un perfil d'episodi abans de generar un podcast.",
    listTitle: "Podcasts",
    listDesc: "Fes un seguiment dels episodis generats i gestiona els perfils reutilitzables.",
    chooseAView: "Tria una vista",
    episodesTab: "Episodis",
    templatesTab: "Perfils",
    overviewTitle: "Visió general dels episodis",
    overviewDesc: "Supervisa els treballs de generació de podcasts i revisa els artefactes finals.",
    generateBtn: "Genera un podcast",
    total: "Total",
    processingLabel: "S'està processant",
    completedLabel: "Completat",
    failedLabel: "Ha fallat",
    pendingLabel: "Pendent",
    loadErrorTitle: "Ha fallat la càrrega dels episodis",
    loadErrorDesc: "No s'han pogut obtenir els darrers episodis de podcast. Torna-ho a provar en breu.",
    loadingEpisodes: "S'estan carregant els episodis…",
    noEpisodesYet: "Encara no hi ha episodis de podcast. Genera el primer des de les interfícies de xat del quadern o la font.",
    statusRunningTitle: "S'està processant",
    statusRunningDesc: "Episodis que estan generant recursos activament.",
    statusPendingTitle: "En cua / Pendent",
    statusPendingDesc: "Episodis enviats que esperen per iniciar el processament.",
    statusCompletedTitle: "Episodis completats",
    statusCompletedDesc: "Llestos per revisar, baixar o publicar.",
    statusFailedTitle: "Episodis fallats",
    statusFailedDesc: "Episodis que han tingut problemes durant la generació.",
    templatesWorkspaceTitle: "Àrea de treball de perfils",
    templatesWorkspaceDesc: "Crea configuracions d'episodis i locutors reutilitzables per a una producció de podcasts ràpida.",
    howTemplatesPowerTitle: "Com els perfils impulsen la generació de podcasts",
    howTemplatesPowerDesc: "Els perfils divideixen el flux de treball del podcast en dos blocs reutilitzables. Combina'ls quan generis un episodi nou.",
    episodeProfilesSetFormat: "Els perfils d'episodi defineixen el format",
    episodeProfilesList1: "Indiquen el nombre de segments i com flueix la narració",
    episodeProfilesList2: "Seleccionen els models de llenguatge per a la presentació, l'esquema i l'escriptura del guió",
    episodeProfilesList3: "Emmagatzemen presentacions per defecte perquè cada episodi comenci amb un to coherent",
    speakerProfilesBringVoices: "Els perfils de locutor donen vida a les veus",
    speakerProfilesList1: "Selecciona el proveïdor i el model de text a veu",
    speakerProfilesList2: "Captura la personalitat, la història de fons i les notes de pronunciació per locutor",
    speakerProfilesList3: "Reutilitza les mateixes veus de presentador o convidat en diferents formats d'episodi",
    recommendedWorkflow: "Flux de treball recomanat",
    workflowStep1: "Crea perfils de locutor per a cada veu que necessitis",
    workflowStep2: "Crea perfils d'episodi que facin referència a aquests locutors pel nom",
    workflowStep3: "Genera podcasts seleccionant el perfil d'episodi que s'adapti a la narració",
    workflowHint: "Els perfils d'episodi fan referència als perfils de locutor pel nom, de manera que començar pels locutors evita assignacions de veu mancants més endavant.",
    failedToLoadTemplates: "Ha fallat la càrrega de les dades dels perfils",
    failedToLoadTemplatesDesc: "Assegura't que l'API s'està executant i torna-ho a provar. Algunes seccions poden estar incompletes.",
    loadingTemplates: "S'estan carregant els perfils…",
    speakerProfilesTitle: "Perfils de locutor",
    speakerProfilesDesc: "Configura les veus i les personalitats per als episodis generats.",
    createSpeaker: "Crea un locutor",
    noSpeakerProfiles: "Encara no hi ha perfils de locutor. Crea'n un per fer disponibles els perfils d'episodi.",
    noDescription: "No s'ha proporcionat cap descripció.",
    usedByCount_one: "Usat per 1 episodi",
    usedByCount_other: "Usat per {count} episodis",
    usedByCount: "Usat per {count} episodis",
    unused: "No usat",
    voiceId: "ID de veu",
    backstory: "Història de fons",
    personality: "Personalitat",
    edit: "Edita",
    duplicate: "Duplica",
    deleteSpeakerProfileTitle: "Vols suprimir el perfil del locutor?",
    deleteSpeakerProfileDesc: "La supressió de «{name}» no es pot desfer.",
    deleteSpeakerDisabledHint: "Elimina aquest locutor dels perfils d'episodi abans de suprimir-lo.",
    deleting: "S'està suprimint…",
    episodeProfilesTitle: "Perfils d'episodi",
    episodeProfilesDesc: "Defineix la configuració de generació reutilitzable per als teus programes.",
    createProfile: "Crea un perfil",
    createSpeakerFirst: "Crea un perfil de locutor abans d'afegir un perfil d'episodi.",
    noEpisodeProfiles: "Encara no hi ha perfils d'episodi. Crea'n un per iniciar la generació de podcasts.",
    speakerCreated: "S'ha creat el locutor",
    speakerCreatedDesc: "El locutor «{name}» s'ha afegit correctament.",
    failedToCreateSpeaker: "Ha fallat la creació del perfil del locutor",
    speakerUpdated: "S'ha actualitzat el locutor",
    speakerUpdatedDesc: "El locutor «{name}» s'ha actualitzat correctament.",
    failedToUpdateSpeaker: "Ha fallat l'actualització del perfil del locutor",
    speakerDeleted: "S'ha suprimit el locutor",
    speakerDeletedDesc: "El locutor «{name}» s'ha eliminat correctament.",
    failedToDeleteSpeaker: "Ha fallat la supressió del perfil del locutor",
    speakerDuplicated: "S'ha duplicat el locutor",
    speakerDuplicatedDesc: "El locutor «{name}» s'ha duplicat correctament.",
    failedToDuplicateSpeaker: "Ha fallat la duplicació del perfil del locutor",
    generationStarted: "S'ha iniciat la generació",
    generationStartedDesc: "S'ha afegit la generació del podcast a la cua.",
    failedToStartGeneration: "Ha fallat l'inici de la generació",
    tryAgainMoment: "Torna-ho a provar en un moment.",
    deleteProfileTitle: "Vols suprimir el perfil?",
    deleteProfileDesc: "Això eliminarà «{name}». Els episodis existents conserven les seves dades, però els nous ja no usaran aquesta configuració.",
    profileCreated: "S'ha creat el perfil",
    profileCreatedDesc: "El perfil d'episodi «{name}» s'ha creat correctament.",
    failedToCreateProfile: "Ha fallat la creació del perfil",
    profileUpdated: "S'ha actualitzat el perfil",
    profileUpdatedDesc: "El perfil d'episodi «{name}» s'ha actualitzat correctament.",
    failedToUpdateProfile: "Ha fallat l'actualització del perfil",
    profileDeleted: "S'ha suprimit el perfil",
    profileDeletedDesc: "El perfil d'episodi «{name}» s'ha eliminat correctament.",
    failedToDeleteProfile: "Ha fallat la supressió del perfil",
    failedToDeleteProfileDesc: "Ha fallat l'eliminació del perfil d'episodi.",
    profileDuplicated: "S'ha duplicat el perfil",
    profileDuplicatedDesc: "El perfil d'episodi «{name}» s'ha duplicat correctament.",
    failedToDuplicateProfile: "Ha fallat la duplicació del perfil",
    episodeDeleted: "S'ha suprimit l'episodi",
    episodeDeletedDesc: "L'episodi s'ha eliminat correctament.",
    failedToDeleteEpisode: "Ha fallat la supressió de l'episodi",
    failedToDeleteSpeakerDesc: "Ha fallat l'eliminació del perfil del locutor.",
    outlineModel: "Model d'esquema",
    transcriptModel: "Model de transcripció",
    segments: "Segments",
    defaultBriefingTitle: "Presentació per defecte",
    created: "Creat el {time}",
    details: "Detalls",
    summaryTab: "Resum",
    outlineTab: "Esquema",
    transcriptTab: "Transcripció",
    briefing: "Presentació",
    noOutline: "No hi ha cap esquema disponible.",
    noTranscript: "No hi ha cap transcripció disponible.",
    deleteEpisodeTitle: "Vols suprimir l'episodi?",
    deleteEpisodeDesc: "Això eliminarà «{name}» i el seu fitxer d'àudio de manera permanent.",
    audioUnavailable: "Àudio no disponible",
    segment: "Segment",
    speaker: "Locutor",
    profile: "Perfil",
    link: "Enllaç",
    file: "Fitxer",
    embedded: "Incrustat",
    notEmbedded: "No incrustat",
    noSpeakerProfilesAvailable: "No hi ha perfils de locutor disponibles",
    editEpisodeProfile: "Edita el perfil de l'episodi",
    createEpisodeProfile: "Crea un perfil d'episodi",
    episodeProfileFormDesc: "Defineix com s'han de generar els episodis i quina configuració de locutor utilitzen per defecte.",
    noSpeakerProfilesDesc: "Crea un perfil de locutor abans de configurar un perfil d'episodi.",
    profileName: "Nom del perfil",
    profileNamePlaceholder: "per exemple, Debat tecnològic",
    descriptionPlaceholder: "Breu resum de quan usar aquest perfil",
    speakerConfig: "Configuració del locutor",
    selectSpeakerProfile: "Selecciona un perfil de locutor",
    outlineGeneration: "Generació d'esquema",
    transcriptGeneration: "Generació de transcripció",
    defaultBriefingPlaceholder: "Descriu l'estructura, el to i els objectius d'aquest format d'episodi",
    editSpeakerProfile: "Edita el perfil del locutor",
    createSpeakerProfile: "Crea un perfil de locutor",
    speakerProfileFormDesc: "Configura els paràmetres de text a veu i defineix fins a quatre locutors.",
    speakers: "Locutors",
    speakersDesc: "Configura entre una i quatre veus per a aquest perfil.",
    addSpeaker: "Afegeix un locutor",
    speakerNumber: "Locutor {number}",
    backstoryPlaceholder: "Breu biografia o context del locutor",
    personalityPlaceholder: "Descriu l'estil i el to",
    outlineModelRequired: "Cal un model d'esquema",
    transcriptModelRequired: "Cal un model de transcripció",
    defaultBriefingRequired: "Cal una presentació per defecte",
    segmentsInteger: "Ha de ser un nombre enter",
    segmentsMin: "Almenys 3 segments",
    segmentsMax: "Màxim 20 segments",
    voiceIdRequired: "Cal un ID de veu",
    backstoryRequired: "Cal una història de fons",
    personalityRequired: "Cal una personalitat",
    speakerCountMin: "Cal almenys un locutor",
    speakerCountMax: "Pots configurar fins a 4 locutors",
    delete: "Suprimeix",
    failedToDelete: "Ha fallat la supressió del podcast",
    retry: "Reintenta",
    retrying: "S'està reintentant…",
    retryStarted: "S'ha iniciat el reintent",
    retryStartedDesc: "S'ha enviat un nou treball de generació de podcast.",
    failedToRetry: "Ha fallat el reintent de l'episodi",
    errorDetails: "Detalls de l'error",
    language: "Idioma",
    languagePlaceholder: "Selecciona un idioma (opcional)",
    podcastLanguage: "Idioma del podcast",
    selectOutlineModel: "Selecciona el model d'esquema",
    selectTranscriptModel: "Selecciona el model de transcripció",
    voiceModel: "Model de veu",
    voiceModelRequired: "Cal un model de veu",
    selectVoiceModel: "Selecciona el model de veu",
    perSpeakerTtsOverride: "Substitució de TTS per locutor (opcional)",
    useProfileDefault: "Usa el valor per defecte del perfil",
    setupRequired: "Cal configuració",
    setupRequiredDesc: "Alguns perfils encara no tenen models configurats. Edita'ls per seleccionar models abans de generar podcasts.",
    notConfigured: "No configurat",
  },
  settings: {
    contentProcessing: "Processament de contingut",
    contentProcessingDesc: "Configura com es processen els documents i les URL",
    docEngine: "Motor de processament de documents",
    docEnginePlaceholder: "Selecciona el motor de processament de documents",
    urlEngine: "Motor de processament d'URL",
    urlEnginePlaceholder: "Selecciona el motor de processament d'URL",
    autoRecommended: "Automàtic (recomanat)",
    simple: "Simple",
    docling: "Docling",
    helpMeChoose: "Ajuda'm a triar",
    docHelp: "· Docling és una mica més lent però més precís, especialment si els documents contenen taules i imatges. · Simple extreu qualsevol contingut del document sense donar-li format. · Automàtic (recomanat) intentarà processar amb docling i, si falla, usarà simple.",
    firecrawl: "Firecrawl",
    jina: "Jina",
    urlHelp: "· Firecrawl és un servei de pagament (amb nivell gratuït) i és molt potent. · Jina és una bona opció i també té un nivell gratuït. · Simple usarà l'extracció HTTP bàsica i no podrà accedir al contingut de llocs web basats en JavaScript. · Automàtic (recomanat) intentarà usar Firecrawl, després Jina i, finalment, usarà simple.",
    embeddingAndSearch: "Incrustació i cerca",
    embeddingAndSearchDesc: "Configura les opcions de cerca i incrustació",
    defaultEmbeddingOption: "Opció d'incrustació per defecte",
    embeddingOptionPlaceholder: "Selecciona l'opció d'incrustació",
    ask: "Pregunta",
    always: "Sempre",
    never: "Mai",
    embeddingHelp: "La incrustació del contingut facilita que tu i els teus agents d'IA el trobeu. Si estàs executant un model d'incrustació local (Ollama, per exemple), no t'has de preocupar pel cost i pots incrustar-ho tot.",
    fileManagement: "Gestió de fitxers",
    fileManagementDesc: "Configura el maneig de fitxers i les opcions d'emmagatzematge",
    autoDeleteFiles: "Supressió automàtica de fitxers",
    autoDeletePlaceholder: "Selecciona l'opció de supressió automàtica",
    filesHelp: "Un cop els fitxers s'han carregat i processat, ja no calen. La majoria d'usuaris haurien de permetre que Open Notebook suprimeixi automàticament els fitxers carregats de la carpeta de càrrega.",
    loadFailed: "Ha fallat la càrrega de la configuració",
  },
  advanced: {
    title: "Eines avançades",
    desc: "Eines i utilitats avançades per a usuaris experimentats",
    systemInfo: "Informació del sistema",
    rebuildEmbeddings: "Reconstrueix les incrustacions",
    rebuildEmbeddingsDesc: "Reconstrueix l'índex de cerca vectorial per a totes les fonts",
    currentVersion: "Versió actual",
    latestVersion: "Darrera versió",
    status: "Estat",
    updateAvailable: "La versió {version} és disponible",
    updateAvailableDesc: "Hi ha una nova versió d'Open Notebook disponible.",
    upToDate: "Actualitzat",
    unknown: "Desconegut",
    viewOnGithub: "Visualitza a GitHub",
    updateCheckFailed: "No es pot comprovar si hi ha actualitzacions. És possible que GitHub no sigui accessible.",
    rebuild: {
      mode: "Mode de reconstrucció",
      existing: "Existent",
      all: "Tot",
      existingDesc: "Torna a incrustar només els elements que ja tenen incrustacions (més ràpid, per al canvi de model)",
      allDesc: "Torna a incrustar els elements existents + crea incrustacions per als elements sense cap (més lent, exhaustiu)",
      include: "Inclou a la reconstrucció",
      selectOneError: "Selecciona almenys un tipus d'element per reconstruir",
      starting: "S'està iniciant la reconstrucció...",
      startBtn: "🚀 Inicia la reconstrucció",
      queued: "En cua",
      running: "S'estan enviant treballs...",
      completed: "Treballs enviats!",
      failed: "Ha fallat",
      leavePageHint: "Pots abandonar aquesta pàgina, ja que s'executarà en segon pla",
      startNew: "Inicia una reconstrucció nova",
      itemsProcessed: "{processed}/{total} treballs enviats ({percent}%)",
      failedItems: "No s'han pogut enviar {count} treballs",
      time: "Temps",
      whenToRebuild: "Quan hauria de reconstruir les incrustacions?",
      whenToRebuildAns: "Hauries de reconstruir quan canviïs de model, actualitzis versions, corregeixis danys o després d'importacions massives.",
      howLong: "Quant de temps triga la reconstrucció?",
      howLongAns: "El temps de processament depèn del nombre d'elements, la velocitat del model i els límits de taxa de l'API. Els models locals solen ser molt ràpids.",
      isSafe: "És segur reconstruir mentre s'usa l'aplicació?",
      isSafeAns: "Sí, la reconstrucció és segura! No suprimeix el contingut, només substitueix les incrustacions, i gestiona els errors correctament.",
    },
  },
  transformations: {
    title: "Transformacions",
    desc: "Les transformacions són instruccions que el model de llenguatge usarà per processar una font i extreure'n anàlisis, resums, etc.",
    workspace: "Tria una àrea de treball",
    playground: "Camp de proves",
    defaultPrompt: "Instrucció de transformació per defecte",
    defaultPromptDesc: "S'afegirà a totes les teves instruccions de transformació",
    defaultPromptPlaceholder: "Introdueix les instruccions de transformació per defecte...",
    listTitle: "Transformacions personalitzades",
    createNew: "Crea de nova",
    inputLabel: "Text d'entrada",
    inputPlaceholder: "Introdueix algun text per transformar...",
    outputLabel: "Sortida",
    runTest: "Executa la transformació",
    running: "S'està executant...",
    selectToStart: "Selecciona una transformació per començar",
    name: "Nom",
    namePlaceholder: "Identificador únic, p. ex. temes_clau",
    titlePlaceholder: "Títol visualitzat, el nom per defecte",
    promptPlaceholder: "Escriu la instrucció que alimentarà aquesta transformació...",
    descriptionPlaceholder: "Descriu què fa aquesta transformació.",
    suggestDefault: "Suggerir per defecte a les fonts noves",
    promptHint: "Les instruccions s'han d'escriure tenint en compte el contingut de la font. Pots demanar al model que resumeixi, extregui anàlisis o produeixi sortides estructurades com taules.",
    createSuccess: "S'ha creat la transformació correctament",
    updateSuccess: "S'ha actualitzat la transformació correctament",
    deleteSuccess: "S'ha suprimit la transformació correctament",
    noTransformations: "Encara no hi ha transformacions",
    createOne: "Crea una transformació per començar",
    selectModel: "Selecciona un model",
    deleteConfirm: "Segur que vols suprimir aquesta transformació?",
    model: "Model",
    systemPrompt: "Instrucció del sistema",
    overrideModelDesc: "Substitueix el model per defecte per a aquesta sessió de xat. Deixa-ho buit per usar el valor per defecte del sistema.",
    sessionUseReplacement: "Aquesta sessió usarà {name} en lloc del model per defecte.",
    systemDefault: "Valor per defecte del sistema",
  },
  models: {
    embedding: "Models d'incrustació",
    tts: "Text a veu (TTS)",
    stt: "Veu a text (STT)",
    apiKey: "Clau de l'API",
    deleteSuccess: "S'ha suprimit el model correctament",
    saveSuccess: "S'ha desat el model correctament",
    noModels: "Sense models",
    discoverModels: "Descobreix models",
    noModelsFound: "No s'ha trobat cap model d'aquest proveïdor",
    modelType: "Tipus de model",
    modelTypeHint: "Selecciona el tipus per als models que vols afegir. Si necessites tipus diferents, afegeix-los en lots separats.",
    deleteModel: "Suprimeix el model",
    defaultAssignments: "Assignacions de model per defecte",
    defaultAssignmentsDesc: "Configura quins models s'usaran per a diferents propòsits a Open Notebook",
    missingRequiredModels: "Falten models obligatoris: {models}. Open Notebook pot no funcionar correctament sense aquests.",
    selectModelPlaceholder: "Selecciona un model",
    requiredModelPlaceholder: "⚠️ Obligatori - Selecciona un model",
    chatModelLabel: "Model de xat",
    chatModelDesc: "S'usa per a les converses de xat",
    transformationModelLabel: "Model de transformació",
    transformationModelDesc: "S'usa per a resums, anàlisis i transformacions",
    toolsModelLabel: "Model d'eines",
    toolsModelDesc: "S'usa per a la crida de funcions; es recomana OpenAI o Anthropic",
    largeContextModelLabel: "Model de context gran",
    largeContextModelDesc: "S'usa per al processament de documents grans; es recomana Gemini",
    embeddingModelLabel: "Model d'incrustació",
    embeddingModelDesc: "S'usa per a la cerca semàntica i les incrustacions vectorials",
    ttsModelLabel: "Model de text a veu",
    ttsModelDesc: "S'usa per a la generació de podcasts",
    sttModelLabel: "Model de veu a text",
    sttModelDesc: "S'usa per a la transcripció d'àudio",
    embeddingChangeTitle: "Canvi de model d'incrustació",
    embeddingChangeConfirm: "Estàs a punt de canviar el model d'incrustació de {from} a {to}.",
    rebuildRequired: "Important: cal reconstruir",
    rebuildReason: "El canvi del model d'incrustació requereix reconstruir totes les incrustacions existents per mantenir la coherència. Sense reconstruir, les cerques poden retornar resultats incorrectes o incomplets.",
    whatHappensNext: "Què passa a continuació:",
    step1: "S'actualitzarà el model d'incrustació per defecte",
    step2: "Les incrustacions existents romandran sense canvis fins a la reconstrucció",
    step3: "El contingut nou usarà el model d'incrustació nou",
    step4: "Hauries de reconstruir les incrustacions tan aviat com sigui possible",
    proceedToRebuildPrompt: "Vols continuar a la pàgina Avançat per iniciar la reconstrucció ara?",
    changeModelOnly: "Canvia només el model",
    changeAndRebuild: "Canvia i ves a Reconstruir",
    autoAssign: "Assigna els valors per defecte automàticament",
    autoAssigning: "S'està assignant...",
    autoAssignSuccess: "S'han assignat automàticament {count} models per defecte",
    autoAssignNoModels: "No hi ha models disponibles per assignar. Sincronitza primer els models.",
    autoAssignAlreadySet: "Tots els models per defecte ja estan configurats",
    testModel: "Prova el model",
    testModelSuccess: "La prova del model ha tingut èxit",
    testModelFailed: "Ha fallat la prova del model",
    searchOrAddModel: "Cerca o escriu un nom de model...",
    addCustomModel: "Afegeix «{name}»",
  },
  apiKeys: {
    title: "Configura la teva IA amb les teves pròpies claus de l'API",
    description: "Emmagatzema les claus de l'API de manera segura a la base de dades per habilitar els proveïdors d'IA a Open Notebook.",
    encryptionRequired: "Clau de xifratge no configurada",
    encryptionRequiredDescription: "Estableix la variable d'entorn OPEN_NOTEBOOK_ENCRYPTION_KEY a qualsevol cadena secreta per habilitar l'emmagatzematge de claus de l'API a la base de dades.",
    configured: "Configurat",
    notConfigured: "No configurat",
    migrationAvailable: "S'han detectat variables d'entorn",
    migrationDescription: "{count} clau(s) de l'API estan configurades mitjançant variables d'entorn i es poden migrar a la base de dades per facilitar-ne la gestió.",
    migrateToDatabase: "Migra a la base de dades",
    migrating: "S'està migrant...",
    migrationSuccess: "S'han migrat correctament {count} clau(es) de l'API",
    migrationErrors: "{count} clau(es) no s'han pogut migrar",
    migrationNothingToMigrate: "Totes les claus ja estan a la base de dades",
    learnMore: "Aprèn a configurar les claus de l'API →",
    testConnection: "Prova la connexió",
    testSuccess: "Connexió correcta",
    testFailed: "Ha fallat la prova de connexió",
    syncModels: "Sincronitza els models",
    syncSuccess: "S'han descobert {discovered} models, s'han afegit {new} de nous",
    syncNoNew: "S'han descobert {count} models, tots ja estan registrats",
    syncFailed: "Ha fallat la sincronització dels models",
    getApiKey: "Obtén la clau de l'API",
    vertexProject: "ID del projecte de GCP",
    vertexLocation: "Regió",
    vertexCredentials: "Ruta del JSON del compte de servei",
    addConfig: "Afegeix una configuració",
    editConfig: "Edita la configuració",
    deleteConfig: "Suprimeix la configuració",
    configName: "Nom de la configuració",
    configNameHint: "Un nom descriptiu per a aquesta configuració (p. ex., «Producció», «Desenvolupament»)",
    baseUrl: "URL base",
    baseUrlOverrideHint: "Canvia-ho només si has de substituir el punt d'accés de l'API per defecte del proveïdor.",
    numCtx: "Finestra de Context (num_ctx)",
    numCtxHint: "Finestra de context màxima per als models Ollama. Deixa-ho buit per usar el valor per defecte (8192). Augmenta'l només si el teu maquinari pot gestionar una finestra més gran.",
    deleteConfigConfirm: "Segur que vols suprimir «{name}»? Aquesta acció no es pot desfer.",
    configSaveSuccess: "S'ha desat la configuració correctament",
    configUpdateSuccess: "S'ha actualitzat la configuració correctament",
    configDeleteSuccess: "S'ha suprimit la configuració correctament",
    apiKeyEditHint: "Deixa-ho en blanc per conservar la clau de l'API existent",
    decryptionError: "Error de desencriptació",
    decryptionErrorDescription: "No s'ha pogut desencriptar la clau de l'API d'aquesta credencial. La clau d'encriptació pot haver canviat. Suprimeix aquesta credencial i torna-la a crear amb la clau correcta.",
  },
  setupBanner: {
    encryptionRequired: "Clau de xifratge no configurada",
    encryptionRequiredDescription: "Estableix la variable d'entorn OPEN_NOTEBOOK_ENCRYPTION_KEY per habilitar l'emmagatzematge segur de credencials.",
    migrationAvailable: "Migració de clau de l'API disponible",
    migrationDescription: "{count} proveïdor(s) tenen claus de l'API configurades mitjançant variables d'entorn. Migra-les a la base de dades per facilitar-ne la gestió.",
    goToSettings: "Ves a la configuració",
    viewDocs: "Visualitza la documentació",
  },
}
